export default __webpack_public_path__ + "static/media/mongo-db-bg.4218c553.svg";